import { canAccessAccounting } from '../../utils/roleConstants';

export const canCreatePlanningPurchaseOrder = (user) => {
    return canAccessAccounting(user);
};
